import { render, staticRenderFns } from "./Selfie.vue?vue&type=template&id=42687953&"
import script from "./Selfie.vue?vue&type=script&lang=ts&"
export * from "./Selfie.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports